// src/utils/i18nHelper.js
export const parseTitle = (titleString, locale) => {
    try {
      const titleObject = JSON.parse(titleString);
      return titleObject[locale] || titleObject['zh']; // 根据传入的语言选择
    } catch (error) {
      return titleString; // 如果不是JSON格式，直接返回原始值
    }
  };
  